import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const CategoryDiscounts = lazyWithRetry(() => import(/* webpackChunkName: "category-discounts" */'../../component/DiscountsConfig/CategoryDiscounts'))

const CategoryDiscountsPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<CategoryDiscounts />
		</Suspense>
	)
})

CategoryDiscountsPage.displayName = 'CategoryDiscountsPage'
export default CategoryDiscountsPage
